import PropTypes from 'prop-types'
import { SelectCurrencyUnit } from '../../../common/selectCurrencyUnit'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { Filter } from '../../common/header/filterBar'
import { FiscalYear } from '../../common/header/fiscalYear'
import PreferenceSettingHeader from '../preferenceSetting/PreferenceSettingHeader'

export const StickyBar = ({ setIsShowPreferenceSetting }) => {
  return (
    <Filter
      renderLeft={() => (
        <PreferenceSettingHeader
          setIsShowPreferenceSetting={setIsShowPreferenceSetting}
        />
      )}
      renderRight={() => (
        <>
          <FiscalYear />
          <SelectCurrencyUnit screen={SCREEN.SUMMARY} />
        </>
      )}
    />
  )
}

StickyBar.propTypes = {
  setIsShowPreferenceSetting: PropTypes.func,
}
